<div class="thanks-modal">
    <div class="title">thank you!</div>
    <p>One of our Team Members will get back in touch with you soon! Have a Great day!</p>

    <!-- <button mat-raised-button (click)="onNoClick()">go to home</button> -->
    <button class="close-btn" (click)="onNoClick()"><i class="bi bi-x"></i></button>
    <div class="send-img">
        <img src="https://media.iquanta.in/ui_images/send-icon.webp" alt="">
    </div>
</div>